import { jsx as _jsx } from "react/jsx-runtime";
import { refX } from "./MarkerDef.utils.js";
/**
 * Define the shared "arrowhead" marker reused as the tip of every connector arrow.
 * @returns SVG `<defs>` holding the arrowhead marker.
 */
export function MarkerDef() {
    return (_jsx("defs", { children: _jsx("marker", { id: "arrowhead", markerWidth: "10", markerHeight: "7", refX: refX, refY: "3.5", orient: "auto", children: _jsx("polygon", { points: "0 0, 10 3.5, 0 7" }) }) }));
}
//# sourceMappingURL=MarkerDef.js.map